const Info = [
  {
    name: "David Malik",
    job: "Founder @ The Millenials & CEO @ ABC",
    schedule: "02 Free Sessions Available",
    location: "Tample, FL, USA",
    languages: "Greek, English, French",
    profile:
      "Lorem Ipsum is simply dummy text of the printing and type setting industry Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  },

  {
    name: "David Malik",
    job: "Founder @ The Millenials & CEO @ ABC",
    schedule: "02 Free Sessions Available",
    location: "Tample, FL, USA",
    languages: "Greek, English, French",
    profile:
      "Lorem Ipsum is simply dummy text of the printing and type setting industry Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  },

  {
    name: "David Malik",
    job: "Founder @ The Millenials & CEO @ ABC",
    schedule: "02 Free Sessions Available",
    location: "Tample, FL, USA",
    languages: "Greek, English, French",
    profile:
      "Lorem Ipsum is simply dummy text of the printing and type setting industry Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  },

  {
    name: "David Malik",
    job: "Founder @ The Millenials & CEO @ ABC",
    schedule: "02 Free Sessions Available",
    location: "Tample, FL, USA",
    languages: "Greek, English, French",
    profile:
      "Lorem Ipsum is simply dummy text of the printing and type setting industry Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  },
];

export default function getInfo() {
  return Info;
}
